var render, staticRenderFns
import script from "./HeroLong.vue?vue&type=script&lang=js&"
export * from "./HeroLong.vue?vue&type=script&lang=js&"
import style0 from "./HeroLong.vue?vue&type=style&index=0&id=75af44a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75af44a4",
  null
  
)

export default component.exports